var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KToolbar',{style:({ backgroundColor: 'var(--tokens-appBar)' }),attrs:{"title":"Page Title","textColor":"black"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('KIconButton',{attrs:{"icon":"close","color":"var(--tokens-text)","ariaLabel":'Close'}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }